import { render, staticRenderFns } from "./ViewMerchantAgent.vue?vue&type=template&id=6077f776"
import script from "./ViewMerchantAgent.vue?vue&type=script&lang=js"
export * from "./ViewMerchantAgent.vue?vue&type=script&lang=js"
import style0 from "./ViewMerchantAgent.vue?vue&type=style&index=0&id=6077f776&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports